import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';

import {TokenView} from '../openapi-core';
import {environment} from '../../environments/environment';

const handoffIdPattern = /^[A-Za-z0-9_-]{43}$/;

export function isValidHandoffId(handoffId: string | null | undefined): handoffId is string {
  return typeof handoffId === 'string' && handoffIdPattern.test(handoffId);
}

@Injectable({providedIn: 'root'})
export class PortalAuthorizationCallbackService {
  private activeHandoffId: string | null = null;

  constructor(private http: HttpClient) {
  }

  exchange(handoffId: string): Observable<TokenView> {
    if (!isValidHandoffId(handoffId)) {
      return throwError(() => new Error('Invalid authorization handoff id.'));
    }

    return this.http.post<TokenView>(
      `${environment.coreApiUrl}/api/Auth/PortalAuthorizationCode/Exchange`,
      {handoffId},
      {withCredentials: true},
    );
  }

  clearCallbackLocation(): boolean {
    return this.clearSensitiveLocation(window.location.pathname);
  }

  isHandoffInProgress(handoffId: string): boolean {
    return this.activeHandoffId === handoffId;
  }

  beginHandoff(handoffId: string): void {
    this.activeHandoffId = handoffId;
  }

  endHandoff(handoffId: string | null): void {
    if (this.activeHandoffId === handoffId) {
      this.activeHandoffId = null;
    }
  }

  private clearSensitiveLocation(cleanPath: string): boolean {
    try {
      window.history.replaceState(null, '', cleanPath);
      return true;
    } catch {
      // Do not accept a credential while it remains visible. A hard navigation
      // is the only safe fallback when the History API is unavailable.
      this.hardReplaceWithCleanLocation(cleanPath);
      return false;
    }
  }

  private hardReplaceWithCleanLocation(cleanPath: string): void {
    window.location.replace(cleanPath);
  }
}
